var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === _vm.E_Buttons.Start || _vm.type === _vm.E_Buttons.Restart
    ? _c(
        "button",
        _vm._g(
          _vm._b(
            {
              staticClass: "case-time-dlg_btn case-time__start-btn",
              attrs: { type: "button" },
            },
            "button",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c(
            "svg",
            {
              attrs: {
                width: "64",
                height: "64",
                viewBox: "0 0 64 64",
                fill: "none",
              },
            },
            [
              _c("circle", {
                attrs: { cx: "32", cy: "32", r: "32", fill: "#45A321" },
              }),
              _c("rect", {
                attrs: {
                  width: "36",
                  height: "36",
                  transform: "translate(16 14)",
                  fill: "white",
                  "fill-opacity": "0.01",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M26.5 24.23V39.77C26.5 40.955 27.805 41.675 28.81 41.03L41.02 33.26C41.2338 33.1247 41.4098 32.9376 41.5319 32.7159C41.6539 32.4943 41.7179 32.2455 41.7179 31.9925C41.7179 31.7395 41.6539 31.4906 41.5319 31.269C41.4098 31.0474 41.2338 30.8603 41.02 30.725L28.81 22.97C28.5838 22.8237 28.3222 22.7411 28.0529 22.731C27.7837 22.721 27.5167 22.7837 27.2802 22.9128C27.0436 23.0418 26.8463 23.2323 26.709 23.4641C26.5717 23.6959 26.4995 23.9605 26.5 24.23Z",
                  fill: "white",
                },
              }),
            ]
          ),
        ]
      )
    : _vm.type === _vm.E_Buttons.End
    ? _c(
        "button",
        _vm._g(
          _vm._b(
            {
              staticClass: "case-time-dlg_btn case-time__end-btn",
              attrs: { type: "button" },
            },
            "button",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c(
            "svg",
            {
              attrs: {
                width: "64",
                height: "64",
                viewBox: "0 0 64 64",
                fill: "none",
              },
            },
            [
              _c("circle", {
                attrs: { cx: "32", cy: "32", r: "31.5", stroke: "#BCC2CC" },
              }),
              _c("rect", {
                attrs: {
                  x: "23",
                  y: "23",
                  width: "18",
                  height: "18",
                  fill: "#495973",
                },
              }),
            ]
          ),
        ]
      )
    : _vm.type === _vm.E_Buttons.Pause
    ? _c(
        "button",
        _vm._g(
          _vm._b(
            {
              staticClass: "case-time-dlg_btn case-time__pause-btn",
              attrs: { type: "button" },
            },
            "button",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c(
            "svg",
            {
              attrs: {
                width: "64",
                height: "64",
                viewBox: "0 0 64 64",
                fill: "none",
              },
            },
            [
              _c("circle", {
                attrs: { cx: "32", cy: "32", r: "31.5", stroke: "#D11A32" },
              }),
              _c("g", { attrs: { "clip-path": "url(#clip0_99_645)" } }, [
                _c("rect", {
                  attrs: {
                    width: "24",
                    height: "24",
                    transform: "matrix(1 0 0 -1 20 44)",
                    fill: "white",
                    "fill-opacity": "0.01",
                  },
                }),
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M27.502 43.9995C29.1588 43.9995 30.502 42.6564 30.502 40.9995V22.9995C30.502 21.3427 29.1588 19.9995 27.502 19.9995C25.8451 19.9995 24.502 21.3427 24.502 22.9995V40.9995C24.502 42.6564 25.8451 43.9995 27.502 43.9995ZM36.502 43.9995C38.1588 43.9995 39.502 42.6564 39.502 40.9995V22.9995C39.502 21.3427 38.1588 19.9995 36.502 19.9995C34.8451 19.9995 33.502 21.3427 33.502 22.9995V40.9995C33.502 42.6564 34.8451 43.9995 36.502 43.9995Z",
                    fill: "#D11A32",
                  },
                }),
              ]),
              _c("defs", [
                _c("clipPath", { attrs: { id: "clip0_99_645" } }, [
                  _c("rect", {
                    attrs: {
                      width: "24",
                      height: "24",
                      fill: "white",
                      transform: "matrix(1 0 0 -1 20 44)",
                    },
                  }),
                ]),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }